import { UniversalFilterField } from '../../../../../helpers/filters/UniversalFilter';

export {
  UniversalFilterTypes,
  UniversalFilterTextModes
} from '../../../../../helpers/filters/UniversalFilter';

export type CompactIndexTableHeaderSortFilterSearchCellFilterFieldName<
  FiltersType extends Record<string, any>
> = Extract<keyof FiltersType, string>;

export type CompactIndexTableHeaderSortFilterSearchCellFilterField<
  FiltersType
> = UniversalFilterField<FiltersType>;
